import { Typography } from '@navi/web-ui/lib/primitives';
import {
  Tooltip as TooltipV2,
  TooltipContent,
  TooltipTrigger,
  Directions
} from '@cp/src/components/TooltipV2/TooltipV2';

const MockStates = (props: {
  showTooltip: boolean;
  buttonLabel: string;
  tooltipContent: string;
}) => {
  const { showTooltip = false, buttonLabel, tooltipContent } = props;

  if (!showTooltip)
    return (
      <Typography variant="h4" color="var(--text-primary)">
        {buttonLabel}
      </Typography>
    );

  return (
    <TooltipV2 placement={Directions.TOP} mainAxisOffset={6}>
      <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
        <Typography variant="h4" color="var(--text-primary)">
          {buttonLabel}
        </Typography>
      </TooltipTrigger>
      <TooltipContent className="tooltipWrapper max-w-[200px] py-2">
        {tooltipContent}
      </TooltipContent>
    </TooltipV2>
  );
};

export default MockStates;
